import { TEAM_FACTION_NAMES, getDisplayTeamBg } from '../displayTheme';

type TeamColor = 'BLUE' | 'RED' | 'GREEN' | 'YELLOW';

interface BondWinnerDisplayProps {
  voteId: string;
  fromTeam: TeamColor;
  heroName: string;
  heroImageUrl?: string;
  bondText: string;
}

function BondWinnerDisplay({ fromTeam, heroName, heroImageUrl, bondText }: BondWinnerDisplayProps) {
  const bgClass = getDisplayTeamBg(fromTeam);

  return (
    <div className={`h-screen w-screen flex flex-col items-center justify-center p-12 ${bgClass}`}>
      {/* Hero Image */}
      {heroImageUrl && (
        <div className="mb-8">
          <img
            src={heroImageUrl}
            alt={heroName}
            className="w-64 h-64 object-cover rounded-2xl border-4 border-parchment-500/40 shadow-2xl"
          />
        </div>
      )}

      {/* Hero Name */}
      <h1 className="text-6xl font-bold text-parchment-100 font-display mb-4 text-center">
        {heroName}
      </h1>

      {/* Team */}
      <p className="text-2xl text-parchment-400 font-heading mb-8">
        Squadra {TEAM_FACTION_NAMES[fromTeam]}
      </p>

      {/* Bond Text */}
      <div className="display-card p-8 border-yellow-400 max-w-3xl">
        <p className="text-4xl text-yellow-300 font-heading text-center italic">
          "{bondText}"
        </p>
      </div>
    </div>
  );
}

export default BondWinnerDisplay;
